export default "__VITE_ASSET__BeNF6sem__"